/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Sort_Order_InvalidInputs */

const vi_error_shop_sort_order_invalid = /** @type {(inputs: Error_Shop_Sort_Order_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập số nguyên từ 0 trở lên.`)
};

/**

* @param {Error_Shop_Sort_Order_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_sort_order_invalid = /** @type {((inputs?: Error_Shop_Sort_Order_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Sort_Order_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_sort_order_invalid(inputs)
});